import f from "long";
import * as a from "protobufjs/minimal.js";
import "./currency_codes.js";
const r = "default" in a ? a.default : a;
function c() {
  return { $type: "squareup.common.Money", amount: void 0, currencyCode: void 0 };
}
const l = {
  $type: "squareup.common.Money",
  encode(e, n = r.Writer.create()) {
    const u = d();
    try {
      return e.amount !== void 0 && n.uint32(16).int64(e.amount), e.currencyCode !== void 0 && n.uint32(24).int32(e.currencyCode), n;
    } finally {
      u();
    }
  },
  decode(e, n) {
    const u = d();
    try {
      const o = e instanceof r.Reader ? e : r.Reader.create(e);
      let s = n === void 0 ? o.len : o.pos + n;
      const i = c();
      for (; o.pos < s; ) {
        const t = o.uint32();
        switch (t >>> 3) {
          case 2:
            if (t !== 16)
              break;
            i.amount = m(o.int64());
            continue;
          case 3:
            if (t !== 24)
              break;
            i.currencyCode = o.int32();
            continue;
        }
        if ((t & 7) === 4 || t === 0)
          break;
        o.skipType(t & 7);
      }
      return i;
    } finally {
      u();
    }
  },
  create(e) {
    return l.fromPartial(e ?? {});
  },
  fromPartial(e) {
    const n = c();
    return n.amount = e.amount ?? void 0, n.currencyCode = e.currencyCode ?? void 0, n;
  }
};
function m(e) {
  if (e.gt(globalThis.Number.MAX_SAFE_INTEGER))
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (e.lt(globalThis.Number.MIN_SAFE_INTEGER))
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return e.toNumber();
}
const d = () => {
  const e = r.util.Long;
  return r.util.Long = f, r.configure(), () => {
    r.util.Long = e, r.configure();
  };
};
export {
  l as Money
};
